const getCookie = ( cookieName ) => {
	const results = document.cookie.match( "(^|;) ?" + cookieName + "=([^;]*)(;|$)" );
	return results ? decodeURI( results[2] ) : null;
};

const initInfoPopup = () => {
	$( document ).ready( function() {
		const $modalInfo = $( "#modal-info" );

		if ( $modalInfo.length && getCookie( "infoPopup" ) === null ) {
			$modalInfo.modal( "show" );
			document.cookie = `infoPopup=1; path=/; max-age=${ 86400 }`;
		}
	} );
};

$( function() {
	initInfoPopup();
} );
